export const ABOUT_YOUR_LOAN_SCREEN_TITLE = `About Your Loan`;
export const ABOUT_YOUR_SCREEN_TITLE = `About You`;
export const APPENDIX_SCREEN_TITLE = `Hardstop`;
export const APPLICATION_SUMMARY_SCREEN_TITLE = `Application Summary`;
export const ASSERTION_SCREEN_TITLE = `Initial Assertions`;
export const ATTESTTATION_SCREEN_TITLE = `Final Assertions`;
export const EXTEND_TERM_SCREEN_TITLE = `Extend Term`;
export const LANDING_SCREEN_TITLE = `Landing`;
export const REQUEST_REPAYMENT_HOLIDAY_SCREEN_TITLE = `Request Repayment Holiday`;
export const THANK_YOU_SCREEN_TITLE = `Thank You`;
export const YOUR_BBLS_SCREEN_TITLE = `Your Bounce Back Loan`;

//HARDSTOP TITLES
export const HOW_TO_CONTACT_US_TITLE = `Contact Us`;
export const SITE_DOWN_TITLE = `Site Down`;
